import { useCallback, useEffect, useRef, useState } from 'react';

export type CopyStatus = 'idle' | 'copied' | 'failed';

const STATUS_RESET_MS = 2000;

export function useCopyToClipboard() {
  const [status, setStatus] = useState<CopyStatus>('idle');
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const copy = useCallback((value: string) => {
    function onResult(success: boolean) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      setStatus(success ? 'copied' : 'failed');
      timerRef.current = setTimeout(() => setStatus('idle'), STATUS_RESET_MS);
      return success;
    }

    return navigator.clipboard.writeText(value).then(
      () => onResult(true),
      () => onResult(false),
    );
  }, []);

  return { status, copy };
}
